<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11RmtXa/tc-custom/9781625845542.jpg?1704586019549" alt="This image is the cover for the book Wicked Northern Virginia, Wicked"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wicked Northern Virginia, Wicked
      </h1>
      <p class="bookDescription body article font2">
        <p>Behind the bucolic plantation estates of Northern Virginia lies a history of scandal. The region has a rotating cast of greedy supervisors, vain senators, bullying occupiers and party bosses. The Aryan Nations once flooded the streets of Arlington. Infamous floating brothels once sailed the Potomac. Even George Washington's death at his historic estate outside the capital is shrouded in mystery. Join journalist and author Michael Lee Pope as he serves a cookie full of arsenic on a cold platter of revenge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Lee Pope
      </h2>
      
      <p class="authorDescription body article">Michael Lee Pope is an award-winning journalist who lives in Old Town Alexandria. He has reported for the Alexandria Gazette Packet, WAMU 88.5 News, the New York Daily News and the Tallahassee Democrat. A native of Moultrie, Georgia, he grew up in Durham, North Carolina, and graduated from high school in Tampa, Florida. He has a master's degree in American studies from Florida State University, and he lives in the Yates Gardens neighborhood with his lovely wife, Hope Nelson.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?783f3153